import { Head, useForm } from '@inertiajs/react';
import GuestLayout from '@/Layouts/GuestLayout';
import FormInput from '@/Components/FormInput';
import { LockClosedIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

export default function ResetPassword({ token, email }) {
    const { data, setData, post, processing, errors } = useForm({ token, email, password: '', password_confirmation: '' });
    const submit = (e) => { e.preventDefault(); post('/reset-password'); };

    return (
        <GuestLayout>
            <Head title="Reset Password" />
            <div className="text-center mb-6">
                <h2 className="text-lg font-bold text-slate-800">New Password</h2>
                <p className="text-slate-400 text-xs mt-1">Create a new secure password</p>
            </div>
            <form onSubmit={submit} className="space-y-4">
                <FormInput label="Email" type="email" icon={EnvelopeIcon} value={data.email} onChange={e => setData('email', e.target.value)} error={errors.email} required />
                <FormInput label="Password" type="password" icon={LockClosedIcon} value={data.password} onChange={e => setData('password', e.target.value)} error={errors.password} required />
                <FormInput label="Confirm Password" type="password" icon={LockClosedIcon} value={data.password_confirmation} onChange={e => setData('password_confirmation', e.target.value)} error={errors.password_confirmation} required />
                <button type="submit" disabled={processing} className="w-full py-2.5 bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-semibold rounded-xl transition-all shadow-sm disabled:opacity-50">
                    Reset Password
                </button>
            </form>
        </GuestLayout>
    );
}
